/**
 * useDelayedFlag, returns true only if `condition` stays true for `delayMs`.
 *
 * Use for skeleton/loading states: "show skeleton only if the underlying load
 * hasn't completed within 200ms." Fast loads never flash a skeleton, they
 * just paint the real content.
 *
 * Pattern per Ean's feedback 2026-06-02: "no constant teasing loads." Fast
 * fetches feel instant; slow fetches still get the skeleton treatment so the
 * user knows something's happening.
 */

import { useEffect, useState } from 'react';

export function useDelayedFlag(condition: boolean, delayMs = 200): boolean {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    if (!condition) {
      setFlag(false);
      return;
    }
    const id = setTimeout(() => setFlag(true), delayMs);
    return () => clearTimeout(id);
  }, [condition, delayMs]);
  return flag;
}
